import { toast } from 'react-toastify';
import { getAllCourses } from '../api/courses';
import { extractApiError } from '../api/community';
import {
  createNotification,
  NOTIFICATION_TYPE,
} from '../services/Notification';
import { toggleTrialModal } from '../store/action/common';
import { APP_ROUTES, getRoute } from '../route';
import { slugToURL } from './url';

/**
 * Shared error handling for joining a community group.
 * On 403: product-gated groups redirect to the matching course page
 * (fallback: premium courses); subscription-gated groups open the trial modal.
 */
export const handleGroupJoinError = async (
  err,
  enrollmentType,
  { history, dispatch },
) => {
  const fallbackMessage = 'Failed to join the group. Please try again.';

  if (err?.response?.status === 403) {
    const enrollType = enrollmentType?.type;
    if (enrollType === 'product_subscribers_only') {
      const required = enrollmentType?.required_products || [];
      const product = required.find(p => p.active) || required[0];
      if (product) {
        toast.info(`This group requires a subscription to "${product.name}".`);
        try {
          const coursesRes = await getAllCourses();
          const courses = coursesRes?.data?.response?.data || [];
          const matched = courses.find(
            c => String(c?.attributes?.product_id) === String(product.id),
          );
          const slug = matched?.attributes?.slug;
          history.push(
            slug
              ? getRoute(APP_ROUTES.COURSE_SLUG, {
                  pathParam: { slug: slugToURL(slug) },
                })
              : APP_ROUTES.PREMIUM_COURSES,
          );
        } catch {
          history.push(APP_ROUTES.PREMIUM_COURSES);
        }
      }
      return;
    }
    if (enrollType === 'subscribers_only') {
      const apiMessage =
        err?.response?.data?.message ||
        'An active subscription is required to join this group.';
      createNotification({
        type: NOTIFICATION_TYPE.ERROR,
        message: apiMessage,
      });
      dispatch(toggleTrialModal({ open: true, viewAll: false }));
      return;
    }
  }

  createNotification({
    type: NOTIFICATION_TYPE.ERROR,
    message: extractApiError(err, fallbackMessage),
  });
};
